import {Control, RegisterOptions, useController} from 'react-hook-form';
import clsx from 'clsx';
import {CheckIcon, WarningIcon} from '../../icons';
import * as inputStyles from './input.module.css';
import * as styles from './textarea.module.css';

interface ITextarea {
    caption?: string,
    control: Control,
    rules?: RegisterOptions,
    name: string,
    icon?: JSX.Element,
    placeholder?: string,
    title?: string,
    className?: string,
    disabled?: boolean,
}

const Textarea = ({
    caption,
    control,
    rules,
    name,
    icon,
    placeholder,
    title,
    className,
    disabled = false,
}: ITextarea) => {
    const {
        field: {
            onChange,
            onBlur,
            value,
            ref,
        },
        fieldState: {error},
    } = useController({
        name,
        control,
        rules,
    });
    const isError = !!(error);
    const isSuccess = !!(value && !error);

    return (
        <span className={inputStyles.root}>
            <span
                className={clsx(
                    inputStyles.inputWrapper,
                    !title && inputStyles.noTitle,
                )}
            >
                {title && (
                    <span className={inputStyles.title}>
                        {title}
                    </span>
                )}
                {icon && (
                    <span
                        className={clsx(
                            inputStyles.prefixIcon,
                            value && inputStyles.filled,
                        )}
                    >
                        {icon}
                    </span>
                )}
                <textarea
                    name={name}
                    placeholder={placeholder}
                    onChange={onChange}
                    onBlur={onBlur}
                    onFocus={onBlur}
                    className={clsx(
                        styles.textarea,
                        inputStyles.input,
                        disabled && inputStyles.fontGray,
                        icon && inputStyles.withIcon,
                        isError && inputStyles.error,
                        isSuccess && inputStyles.success,
                        className,
                    )}
                    value={value}
                    ref={ref}
                    // eslint-disable-next-line
                    disabled={disabled}
                />
                <span
                    className={clsx(
                        inputStyles.statusIcon,
                        isError && inputStyles.error,
                        isSuccess && inputStyles.success,
                    )}
                >
                    {isError && (<WarningIcon/>)}
                    {isSuccess && (<CheckIcon/>)}
                </span>
                <span
                    className={clsx(
                        inputStyles.messages,
                        isError && inputStyles.error,
                    )}
                >
                    {error && error.message}
                    {(!error && caption) && caption}
                </span>
            </span>
        </span>
    );
};

export default Textarea;
